import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, CircularProgress } from '@material-ui/core';
import packetService from '../../../api/jobcoinsPacketService';
import { cleanPacket } from '../../../redux/actions/jobcoinsPacketActions';
import { showSuccess } from '../../../redux/actions/snackbarActions';

class ConfirmJobcoinsPacketDelete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaving: false
        }
        this.deletePacket = this.deletePacket.bind(this);
    }

    deletePacket() {
        this.setState({
            isSaving: true
        });

        const { id } = this.props.selectedPacket;
        packetService.deletePacket(id)
            .then(() => {
                this.props.onClose();
                this.props.showSuccess('Packet deleted successfully.');
            });
    }

    render() {
        const { showConfirm, onClose, selectedPacket } = this.props;
        if (selectedPacket) {
            return (
                <Dialog
                    open={showConfirm}
                    onClose={onClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Delete this Jobcoins Packet?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure to delete this Jobcoins Packet?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose} color="primary">No, go back</Button>
                        <Button onClick={this.deletePacket} color="primary" disabled={this.state.isSaving} autoFocus>Yes</Button>
                        {this.state.isSaving && <CircularProgress size={24} />}
                    </DialogActions>
                </Dialog>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = store => ({
    selectedPacket: store.jobcoinsPacketState.selectedPacket
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanPacket, showSuccess }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmJobcoinsPacketDelete);